var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.06 16.25C27.06 15.47 26.99 14.72 26.86 14H16.5V18.26H22.42C22.16 19.63 21.38 20.79 20.21 21.57V24.34H23.78C25.86 22.42 27.06 19.6 27.06 16.25Z",
    fill: "#E81717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 27C19.4697 27 21.9597 26.02 23.7797 24.34L20.2097 21.57C19.2297 22.23 17.9797 22.63 16.4997 22.63C13.6397 22.63 11.2097 20.7 10.3397 18.1H6.67969V20.94C8.48969 24.53 12.1997 27 16.4997 27Z",
    fill: "#E81717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.34 18.09C10.12 17.43 9.99 16.73 9.99 16C9.99 15.27 10.12 14.57 10.34 13.91V11.07H6.68C5.93 12.55 5.5 14.22 5.5 16C5.5 17.78 5.93 19.45 6.68 20.93L9.53 18.71L10.34 18.09Z",
    fill: "#E81717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 9.38C18.1197 9.38 19.5597 9.94 20.7097 11.02L23.8597 7.87C21.9497 6.09 19.4697 5 16.4997 5C12.1997 5 8.48969 7.47 6.67969 11.07L10.3397 13.91C11.2097 11.31 13.6397 9.38 16.4997 9.38Z",
    fill: "#E81717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogoRed);
export default __webpack_public_path__ + "static/media/google-logo_red.d3e61b4c3a38221a587168a758557322.svg";
export { ForwardRef as ReactComponent };